export default "__VITE_ASSET__Bu8hOIO9__"